import { customChallengeState } from './atoms';
import { SubmitButtonBase } from '@/presentation/components';
import { useRecoilValue } from 'recoil';
import React from 'react';
const SubmitButton = ({ text }) => {
    const state = useRecoilValue(customChallengeState);
    return React.createElement(SubmitButtonBase, { text: text, state: state });
};
export default SubmitButton;
